/**
 * Created by renlaydel on 05/12/2017.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

class FormattedPercentage extends Component {
  render() {
    const { value, currency = "AUD", symbol = "", currencyDisplay = 'none', useGrouping = true, intl: { formatNumber } } = this.props;

    const opts = {
      useGrouping,
      currency,
      style          : "percent",
      currencyDisplay: "code"
    };

    let formattedNumber = formatNumber( value, opts );
    if ( currencyDisplay === "none" ) {
      formattedNumber = formattedNumber.replace( currency, "" );
    } else if ( currencyDisplay === "symbol" ) {
      formattedNumber = formattedNumber.replace( currency, symbol );
    }

    return (
      <span>
        {formattedNumber}
      </span>
    );
  }
}

FormattedPercentage.propTypes = {
  value          : PropTypes.number.isRequired,
  currency       : PropTypes.string,
  symbol         : PropTypes.string,
  currencyDisplay: PropTypes.oneOf( [ "none", "code", "symbol" ] ),
  useGrouping    : PropTypes.bool,
};

export default injectIntl( FormattedPercentage );
